import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
const uuid = require('uuid');

const Strings = require('../../../../app/shared/Strings');
const ActivityActions = require('../../actions/ActivityActions');
const ActivityStore = require('../../stores/activity_store_reflux');
const PermissionsUtil = require('../../../../app/shared/PermissionsUtil');

const propTypes = {
    inputId: PropTypes.string,
    className: PropTypes.string,
    activityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    channelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    activityLocked: PropTypes.bool.isRequired,
    channelUserPermissions: PropTypes.object,
    projectUserPermissions: PropTypes.object,
};

const defaultProps = {
    inputId: 'act-display-name',
    className: '',
    channelUserPermissions: {},
    projectUserPermissions: {},
};

class ActivityDisplayNameEditor extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            activityStoreState: ActivityStore.getStateActivity(props.activityId, props.projectId, props.channelId),
            displayName: '',
            displayNameClean: true,
            displayNameUpdateActionId: null
        };

        this.setDisplayName = this.setDisplayName.bind(this);
        this.updateDisplayName = this.updateDisplayName.bind(this);

        this.unsubscribes = [ActivityStore.listen(this.onActivityStoreStateChange.bind(this))];
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onActivityStoreStateChange(newState) {
        let updatedState = { activityStoreState: ActivityStore.getStateActivity(this.props.activityId, this.props.projectId, this.props.channelId) };

        if (newState.action.id === this.state.displayNameUpdateActionId) {
            updatedState = { ...updatedState, displayNameClean: true, displayNameUpdateActionId: null };
        }

        this.setState(updatedState);
    }

    setDisplayName(e) {
        this.setState({ displayName: e.target.value, displayNameClean: false })
    }

    updateDisplayName() {
        const actionId = uuid.v4();
        this.setState({ displayNameUpdateActionId: actionId }, () => {
            ActivityActions.setDisplayName(actionId, {
                activityID: this.props.activityId,
                projectID: this.props.projectId,
                displayName: this.state.displayName
            });
        });
    }

    render() {
        if (!this.state.activityStoreState.initialized) {
            return null;
        }

        const storeActivity = this.state.activityStoreState.activity;
        if (!storeActivity) {
            return null;
        }

        const actDisplayName = this.state.displayNameClean ? storeActivity.meta_data.display_name || '' : this.state.displayName;
        const canEditActivity = PermissionsUtil.canEditActivity(this.props.channelUserPermissions, this.props.projectUserPermissions);
        return (
            <div className={this.props.className}>
                <input
                    id={this.props.inputId}
                    type="text"
                    className="actEditMetaDataInput margin-bottom-md"
                    value={actDisplayName}
                    placeholder={storeActivity.meta_data.title}
                    disabled={this.state.activityLocked || !canEditActivity}
                    onChange={this.setDisplayName}
                />
                { canEditActivity &&
                    <div>
                        <Button
                            onClick={this.updateDisplayName}
                            disabled={this.state.displayNameClean || !!this.state.displayNameUpdateActionId || this.props.activityLocked}
                        >
                            {Strings['en'].common.UPDATE}
                        </Button>
                    </div>
                }
            </div>
        );
    }
}

ActivityDisplayNameEditor.propTypes = propTypes;
ActivityDisplayNameEditor.defaultProps = defaultProps;

export default ActivityDisplayNameEditor;